/**
 * Liked products page
 */
import { dispatch } from 'store';
import { ProductType } from 'types/product.types';

import { LIKED_PRODUCTS_ADD } from '../action-types/products-page.action-types';

// eslint-disable-next-line import/prefer-default-export
export const saveLikedProducts = (data: Array<ProductType>) => dispatch({ type: LIKED_PRODUCTS_ADD, data });
